import { handleActions } from "redux-actions";
import { LOGIN_SUCCESS, LOGIN_FAILURE } from "../actionCreators";

const initialState = {
  loginInfo: null,
  loginError: null
};

const loginReducer = handleActions(
  {
    // 로그인 성공
    // localStorage 동기 저장: RouteHome 가 redux state 변경 즉시 BookListContainer 를 마운트하고
    // 그 API 호출이 baseApi request interceptor 의 localStorage.getItem("token") 을 즉시 읽기 때문에,
    // LoginContainer useEffect 보다 먼저 token 이 보장돼야 한다.
    // (reducer 가 pure 가 아니게 되는 trade-off 를 인지하고 적용.)
    [LOGIN_SUCCESS]: (state, { payload: loginInfo }) => {
      try {
        const r = loginInfo && loginInfo.result;
        if (r && r.token) {
          window.localStorage.setItem("token", r.token);
          window.localStorage.setItem("adminYn", r.adminYn || "N");
        }
      } catch (e) {
        // localStorage 차단 환경 무시
      }
      return {
        ...state,
        loginError: null,
        loginInfo: loginInfo.result
      };
    },
    // 로그인 실패
    [LOGIN_FAILURE]: (state, { payload: error }) => ({
      ...state,
      loginError: error
    })
  },
  initialState
);

export default loginReducer;
